export class AnalyticsService {
    static onCreateCanvas() {
        gtag('event', 'create', { 'event_category': 'Canvas'});
    }
    static onRenameCanvas() {
        gtag('event', 'rename', { 'event_category': 'Canvas'});
    }
    static onDeleteCanvas() {
        gtag('event', 'delete', { 'event_category': 'Canvas'});
    }
    static onCreateCanvasItem() {
        gtag('event', 'create-item', { 'event_category': 'Canvas'});
    }
    static onDeleteCanvasItem() {
        gtag('event', 'delete-item', { 'event_category': 'Canvas'});
    }
    static onLogedIn() {
        gtag('event', 'login', { 'event_category': 'User'});
    }
    static onLogedOut() {
        gtag('event', 'logout', { 'event_category': 'User'});
    }
    static onSignedUp() {
        gtag('event', 'create', { 'event_category': 'User'});
    }
    static onAccountDeleted() {
        gtag('event', 'delete', { 'event_category': 'User'});
    }
    static onClickOnFeedback() {
        gtag('event', 'click', { 'event_category': 'Feedback'});
    }
    static onClickOnExport() {
        gtag('event', 'export', { 'event_category': 'Canvas'});
    }
}


// WEBPACK FOOTER //
// ./src/services/AnalyticsService.js